import { render, staticRenderFns } from "./Backup.vue?vue&type=template&id=267dea66&scoped=true&"
import script from "./Backup.vue?vue&type=script&lang=js&"
export * from "./Backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267dea66",
  null
  
)

export default component.exports